import { Input } from '@orobix/orobix-fe-components'
import i18n from 'i18next'
import { useEffect, useState } from 'react'

import { FilterButton } from '../../../components/FilterButton/FilterButton'
import { FilteringValue } from '../../../types/filtering'

type FilterByTextProps = {
  /** Used to derive a unique input id/name, e.g. the column key. */
  id: string
  value: FilteringValue
  onFilter: (value: FilteringValue) => void
  placeholder?: string
}

// Same "commit on blur/Enter" behavior as FilterByRange: typed text is kept
// in local draft state and only forwarded to `onFilter` once the field is
// committed, so it doesn't fire a request (and push browser history) on
// every keystroke.
export const FilterByText = ({
  id,
  value,
  onFilter,
  placeholder,
}: FilterByTextProps) => {
  const [draft, setDraft] = useState(value ?? '')

  useEffect(() => setDraft(value ?? ''), [value])

  const commit = () => onFilter(draft || undefined)

  return (
    <FilterButton
      filter={value}
      onFilter={() => undefined /* draft state drives the input below */}
      renderFilter={() => (
        <Input
          name={id}
          id={id}
          type="text"
          placeholder={placeholder ?? i18n.t('Filter...')}
          value={draft}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setDraft(e.target.value)
          }
          onBlur={commit}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') commit()
          }}
        />
      )}
    />
  )
}
